var NAV = (function($, window, document, undefined){

  var pub = {};

  function replaceQueryParam(key, value, options){
    if (!key || !window || !window.location || !window.history){
      return;
    }
    var opts = options || {};
    var shouldRemove = (value === null || typeof value === 'undefined' || value === '') && opts.removeIfFalsy !== false;
    var stringValue = shouldRemove ? null : String(value);

    try {
      var url = new URL(window.location.href);
      if (shouldRemove){
        url.searchParams.delete(key);
      } else {
        url.searchParams.set(key, stringValue);
      }
      if (opts.clearHash){
        url.hash = '';
      }
      window.history.replaceState({}, document.title, url.toString());
      return;
    } catch (err) {}

    // Fallback for older browsers.
    try {
      var currentSearch = window.location.search || '';
      var hash = opts.clearHash ? '' : (window.location.hash || '');
      var params = new URLSearchParams(currentSearch);
      if (shouldRemove){
        params.delete(key);
      } else {
        params.set(key, stringValue);
      }
      var nextSearch = params.toString();
      var separator = nextSearch ? '?' : '';
      var nextUrl = window.location.pathname + separator + nextSearch + hash;
      window.history.replaceState({}, document.title, nextUrl);
    } catch (e) {}
  }
  pub.replaceQueryParam = replaceQueryParam;

  function nav(){
    var $navToggle = $('#nav-toggle');

    $navToggle.on('click', function(e){
      e.preventDefault();
      $('body').toggleClass('nav-open');
      $(this).toggleClass('active', $('body').hasClass('nav-open'));
    });

    $('#nav-primary a').on('click', function(e){
      e.preventDefault();
      $('body').removeClass('nav-open');
      $navToggle.removeClass('active');
    });
  }

  function getSectionIdFromHref(href){
    if (!href){
      return null;
    }
    if (href.trim() === '#'){
      return null;
    }
    var url;
    try {
      url = new URL(href, window.location.href);
    } catch (e){
      return null;
    }
    var qsSection = url.searchParams.get('section');
    if (qsSection){
      return qsSection.replace(/^#/, '').trim();
    }
    if (url.hash){
      return url.hash.replace(/^#/, '').trim();
    }
    return null;
  }

  // Active link underline that follows the visible section and clicks.
  function navIndicator(){
    var $nav = $('#nav-primary'),
        $links = $nav.find('a');

    if (!$nav.length || !$links.length){
      return;
    }

    var $indicator = $('<span class="nav-active-indicator" aria-hidden="true"></span>');
    $nav.append($indicator);
    hideIndicator();

    var headerHeight = $('#header').outerHeight() || 0;
    var sections = [];
    var suppressAutoSync = false;
    var suppressTimer = null;
    var suppressDuration = 900;
    var observer;

    function pauseAutoSync(customDuration){
      suppressAutoSync = true;
      clearTimeout(suppressTimer);
      var duration = typeof customDuration === 'number' ? customDuration : suppressDuration;
      suppressTimer = setTimeout(function(){
        suppressAutoSync = false;
      }, duration);
    }

    function hideIndicator(){
      $links.removeClass('active');
      $indicator.css('opacity', 0);
    }

    function moveIndicator($active){
      if (!$active || !$active.length){
        return;
      }
      var navOffset = $nav.offset().left;
      var linkOffset = $active.offset().left - navOffset;
      var linkWidth = $active.outerWidth();

      $indicator.css({
        width: linkWidth + 'px',
        transform: 'translateX(' + linkOffset + 'px)',
        opacity: 1
      });
    }

    function setActive($link){
      if (!$link || !$link.length){
        return;
      }
      $links.removeClass('active');
      $link.addClass('active');
      moveIndicator($link);
    }

    function sectionForLink($link){
      var href = $link.attr('href');
      var id = getSectionIdFromHref(href);
      if (!id){
        return null;
      }
      var $section = $('#' + id);
      return $section.length ? $section[0] : null;
    }

    function computeDestination($link){
      var section = sectionForLink($link);
      if (!section){
        return null;
      }
      var headerHeight = $('#header').outerHeight() || 0;
      return Math.max($(section).offset().top - (headerHeight + 8), 0);
    }

    function computeScrollDuration($link){
      var destination = computeDestination($link);
      if (destination === null){
        return suppressDuration;
      }
      var start = $(window).scrollTop();
      var distance = Math.abs(destination - start);
      var base = 320;
      var perPixel = 0.35;
      var min = 450;
      var max = 2000;
      return Math.max(min, Math.min(max, base + distance * perPixel));
    }

    function refreshSectionPositions(){
      sections = $links.map(function(_, link){
        var $link = $(link);
        var section = sectionForLink($link);
        return section ? {
          id: section.id,
          $link: $link,
          top: $(section).offset().top
        } : null;
      }).get().filter(Boolean).sort(function(a, b){
        return a.top - b.top;
      });
    }

    function getActiveFromScroll(){
      if (!sections.length){
        return null;
      }
      var scrollY = $(window).scrollTop();
      var viewTarget = scrollY + (($(window).height() * 0.35) + headerHeight + 8);
      var active = null;

      for (var i = 0; i < sections.length; i++){
        if (sections[i].top <= viewTarget){
          active = sections[i];
        } else {
          break;
        }
      }
      return active;
    }

    function initObserver(){
      if (typeof IntersectionObserver !== 'function'){
        return;
      }

      var sectionNodes = $links.map(function(_, link){
        return sectionForLink($(link));
      }).get().filter(Boolean);

      if (!sectionNodes.length){
        return;
      }

    observer = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (suppressAutoSync){
            return;
          }
          if (entry.isIntersecting){
            var $link = $links.filter('[href="#' + entry.target.id + '"]');
            if ($link.length){
              setActive($link.first());
            } else {
              hideIndicator();
            }
          }
        });
      }, {
      rootMargin: '-' + (headerHeight + 8) + 'px 0px -60% 0px',
        threshold: 0.35
      });

      sectionNodes.forEach(function(section){
        observer.observe(section);
      });
    }

    $links.on('click', function(){
      var $link = $(this);
      var href = $link.attr('href');
      var duration = computeScrollDuration($link);
      pauseAutoSync(duration + 120);
      var id = getSectionIdFromHref(href);
      if (id){
        setActive($link);
      } else {
        hideIndicator();
      }
    });

    refreshSectionPositions();

    var initialId = getSectionIdFromHref(window.location.href);
    var $initial = null;

    if (initialId){
      $initial = $links.filter(function(){
        return getSectionIdFromHref($(this).attr('href')) === initialId;
      }).first();
    }

    if ((!$initial || !$initial.length) && sections.length){
      var fromScroll = getActiveFromScroll();
      if (fromScroll && fromScroll.$link){
        $initial = fromScroll.$link;
      }
    }

    if ($initial && $initial.length){
      setActive($initial);
    } else {
      hideIndicator();
    }

    var ticking = false;
    function onScrollOrResize(){
      if (!ticking){
        ticking = true;
        window.requestAnimationFrame(function(){
          if (suppressAutoSync){
            moveIndicator($links.filter('.active').first());
            ticking = false;
            return;
          }
          headerHeight = $('#header').outerHeight() || 0;
          refreshSectionPositions();
          var active = getActiveFromScroll();
          if (active && active.$link){
            setActive(active.$link);
          } else {
            hideIndicator();
          }
          ticking = false;
        });
      }
    }

    $(window).on('scroll resize', onScrollOrResize);

    initObserver();

    $(window).on('resize', function(){
      var $current = $links.filter('.active').first();
      moveIndicator($current);
    });
  }

  function smoothScroll(){
    var dynamicOffset = function($target){
      var headerHeight = $('#header').outerHeight() || 0;
      return -(headerHeight + 8);
    };

    var dynamicDuration = function(distance){
      var base = 120;
      var perPixel = 0.2;
      var min = 300;
      var max = 2000;
      return Math.max(min, Math.min(max, base + distance * perPixel));
    };

    function scrollToSection(sectionId, shouldUpdateUrl, options){
      var opts = options || {};
      var immediate = opts.immediate === true;
      if (!sectionId){
        return;
      }
      var $target = $('#' + sectionId);
      if (!$target.length){
        return;
      }
      var targetTop = $target.offset().top + dynamicOffset($target);
      var distance = Math.abs(targetTop - $(window).scrollTop());
      if (immediate){
        $('html, body').stop().scrollTop(targetTop);
      } else {
        $('html, body').stop().animate(
          { scrollTop: targetTop },
          {
            duration: dynamicDuration(distance),
            step: function(now, fx){
              // Keep destination in sync if header height changes mid-animation.
              var updatedTarget = $target.offset().top + dynamicOffset($target);
              if (Math.abs(updatedTarget - fx.end) > 1){
                fx.end = updatedTarget;
              }
            }
          }
        );
      }

      if (shouldUpdateUrl){
        replaceQueryParam('section', sectionId, { clearHash: true, removeIfFalsy: false });
      }
    }

    $('body').on('click', 'a[href*="#"], a[href*="section="]', function(e){
      var href = $(this).attr('href') || '';
      if (!href || href.trim() === '#'){
        console.log('preventing empty anchor jump');
        e.preventDefault();
        return;
      }
      var sectionId = getSectionIdFromHref(href);
      if (!sectionId){
        return;
      }
      var url = new URL(href, window.location.href);
      if (url.pathname !== window.location.pathname){
        return;
      }
      e.preventDefault();
      scrollToSection(sectionId, true);
    });

    var initialSection = getSectionIdFromHref(window.location.href);
    if (initialSection){
      setTimeout(function(){
        scrollToSection(initialSection, false, { immediate: true });
      }, 50);
    }
  }

  // Observe a single element (DOM node, selector, or jQuery obj) and fire when
  // it stays visible for the given duration. Returns a cleanup function.
  function observeVisibilityDuration(target, options){
    var el = null;
    if (target){
      if (target.nodeType === 1){
        el = target;
      } else if (target.jquery){
        el = target[0];
      } else if (typeof target === 'string'){
        el = $(target).get(0);
      }
    }
    if (!el || typeof IntersectionObserver !== 'function'){
      return function(){};
    }

    var opts = options || {};
    var threshold = typeof opts.threshold === 'number' ? opts.threshold : 0.35;
    var requiredMs = typeof opts.duration === 'number' ? opts.duration : 3000;
    var onReached = typeof opts.onReached === 'function' ? opts.onReached : function(){};
    var repeat = opts.repeat === true;
    var requireHide = false;

    var startedAt = null;
    var timer = null;
    var completed = false;
    var isVisible = false;
    var observer;

    function clearTimer(){
      if (timer){
        clearTimeout(timer);
        timer = null;
      }
    }
    function finish(){
      if (completed && !repeat) return;
      clearTimer();
      if (!repeat){
        completed = true;
        if (observer){
          observer.disconnect();
        }
      }
      onReached();

      if (repeat){
        startedAt = null;
        requireHide = true;
      }
    }
    function onVisibleStart(){
      if (completed && !repeat) return;
      if (requireHide) return;
      if (startedAt !== null) return;
      isVisible = true;
      startedAt = Date.now();
      // If this is a repeat while still visible, just start a fresh timer.
      timer = setTimeout(finish, requiredMs);
    }
    function onVisibleEnd(){
      if (startedAt === null){
        isVisible = false;
        requireHide = false;
        return;
      }
      startedAt = null;
      isVisible = false;
      requireHide = false;
      clearTimer();
    }
    observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.target !== el){
          return;
        }
        if (entry.isIntersecting){
          onVisibleStart();
        } else {
          onVisibleEnd();
        }
      });
    }, {
      threshold: threshold
    });
    observer.observe(el);

    return function(){
      clearTimer();
      if (observer){
        observer.disconnect();
      }
    };
  }
  pub.observeVisibilityDuration = observeVisibilityDuration;

  // TODO: this code is very flakey and doesn't register all sections
  // being visible accurately. Improve it.
  function sectionUrlSync(){
    if (typeof IntersectionObserver !== 'function'){
      return;
    }

    var $links = $('#nav-primary a');
    if (!$links.length){
      return;
    }

    var navSectionIds = $links.map(function(_, link){
      return getSectionIdFromHref($(link).attr('href'));
    }).get().filter(Boolean);

    var sections = navSectionIds.map(function(id){
      var el = document.getElementById(id);
      return el ? { id: id, el: el } : null;
    }).filter(Boolean);

    if (!sections.length){
      return;
    }

    var headerHeight = $('#header').outerHeight() || 0;
    var currentId = null;

    function updateUrl(nextId){
      if (nextId === currentId){
        return;
      }
      currentId = nextId;
      replaceQueryParam('section', nextId, { clearHash: true, removeIfFalsy: true });
    }

    var observer = new IntersectionObserver(function(entries){
      var visible = entries.filter(function(entry){
        return entry.isIntersecting;
      }).sort(function(a, b){
        return b.intersectionRatio - a.intersectionRatio;
      });

      if (visible.length){
        var topId = visible[0].target.id;
        if (navSectionIds.indexOf(topId) !== -1){
          updateUrl(topId);
          return;
        }
      }
      updateUrl(null);
    }, {
      rootMargin: '-' + (headerHeight + 8) + 'px 0px -55% 0px',
      threshold: [0.35, 0.55, 0.75]
    });

    sections.forEach(function(section){
      observer.observe(section.el);
    });

    var ticking = false;
    function handleScrollOrResize(){
      if (ticking){
        return;
      }
      ticking = true;
      window.requestAnimationFrame(function(){
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        var best = { id: null, ratio: 0 };

        sections.forEach(function(section){
          var rect = section.el.getBoundingClientRect();
          var visibleTop = Math.max(rect.top, 0);
          var visibleBottom = Math.min(rect.bottom, viewportHeight);
          var visibleHeight = Math.max(0, visibleBottom - visibleTop);
          var ratio = viewportHeight ? (visibleHeight / viewportHeight) : 0;
          if (ratio > best.ratio){
            best = { id: section.id, ratio: ratio };
          }
        });

        var enterRatio = 0.32;
        var exitRatio = 0.18;
        var switchDelta = 0.05;

        function ratioFor(id){
          var found = sections.find(function(s){ return s.id === id; });
          if (!found){
            return 0;
          }
          var rect = found.el.getBoundingClientRect();
          var vt = Math.max(rect.top, 0);
          var vb = Math.min(rect.bottom, viewportHeight);
          var vh = Math.max(0, vb - vt);
          return viewportHeight ? (vh / viewportHeight) : 0;
        }

        var currentRatio = currentId ? ratioFor(currentId) : 0;
        var bestIsNav = navSectionIds.indexOf(best.id) !== -1;

        if (!currentId){
          if (bestIsNav && best.ratio >= enterRatio){
            updateUrl(best.id);
          } else {
            updateUrl(null);
          }
        } else {
          if (best.id === currentId){
            if (currentRatio >= exitRatio){
              updateUrl(currentId);
            } else {
              updateUrl(null);
            }
          } else {
            var shouldSwitch = bestIsNav &&
              best.ratio >= enterRatio &&
              best.ratio >= (currentRatio + switchDelta);
            if (shouldSwitch){
              updateUrl(best.id);
            } else if (currentRatio >= exitRatio){
              updateUrl(currentId);
            } else {
              updateUrl(null);
            }
          }
        }
        ticking = false;
      });
    }

    $(window).on('scroll resize', handleScrollOrResize);
    handleScrollOrResize();
  }

  $(function(){
    nav();
    navIndicator();
    smoothScroll();
    sectionUrlSync();
  });

  return pub;
})(jQuery, window, document);

